import { usePage } from "@inertiajs/inertia-react"

export const getErrorsForArray = (errors, property) => {
  return Object.keys(errors)
    .filter(key => key.startsWith(property))
    .reduce((obj, key) => {
      obj.push(errors[key][0])
      return obj
    }, [])
}

export const can = (user, permission) => {
  return user.permissions[permission] === true
}
